import { Util } from "../services/Utils/Util";
import { Room } from "./Room";
import { User } from "./User";


//roomcalls
export class RoomCall {
  static COL = 'roomcalls';
  id: string;
  userIds: string[] = []  // Used for query
  users: User[] = [];   // Used for showing
  updated: Date = new Date();

  constructor(public room: Room) {
    this.id = room.id;
  }

  static addUser(rc: RoomCall, user: User) {
    if (!rc.userIds.includes(user.id)) {
      rc.userIds.push(user.id);
    }
    if (rc.users.find(u => u.id == user.id) == null) {
      rc.users.push(user);
    }
    rc.updated = new Date();
  }

  static removeUser(rc: RoomCall, userId: string) {
    if (rc.userIds.includes(userId)) {
      rc.userIds = rc.userIds.filter(id => id != userId)
    }
    if (rc.users.find(u => u.id == userId) != null) {
      rc.users = rc.users.filter(u => u.id != userId)
    }
    rc.updated = new Date();
  }

  static isActive(rc: RoomCall | undefined): boolean {
    return !!rc && rc.userIds.length > 0 && Util.nrMinAgo(rc.updated) < 60 * 4;
  }
}